
import {
  Component, Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import AttachmentWithStatus from '@/components/AttachmentWithStatus.vue';
import {
  getLeadCustomValueText,
  getLeadCustomValueDate,
} from '@/helpers';
import { BoxStatusType } from '@/types';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import EditConnectionDialogMixin from '@/mixins/EditConnectionDialogMixin.vue';

moment.locale('it');

@Component({
  components: {
    DatePickerDialog,
    AttachmentWithStatus,
  },
})
// eslint-disable-next-line max-len
export default class EditConnectionStatusDialog extends Mixins(EditConnectionDialogMixin, UtilsMixin) {
  selectedStatus: 'completed' | 'error' = 'completed'

  egridConnectionStatus: string | null = null
  egridConnectionDate: Date | null = null
  egridConnectionTime: string | null = null
  egridConnectionNotes: string | null | undefined = null
  egridDistributorAddress: string | null | undefined = null

  suggestedEgridConnectionDate1: Date | null = null
  suggestedEgridConnectionTime1: string | null = null
  suggestedEgridConnectionDate2: Date | null = null
  suggestedEgridConnectionTime2: string | null = null

  egridConnectionActiveDate: Date | null = null

  suggestedDate1AppendIcon: string | false = false
  suggestedDate2AppendIcon: string | false = false

  suggestedDate1Hint: string | null = null
  suggestedDate2Hint: string | null = null

  egridConnectionStatusValues = [
    {
      text: 'Data proposta',
      value: 'suggested',
    },
    {
      text: 'Data concordata (da confermare a portale)',
      value: 'not-confirmed',
    },
    {
      text: 'Data concordata (non necessaria conferma a portale)',
      value: 'no-confirmation-required',
    },
    {
      text: 'Data confermata',
      value: 'confirmed',
    },
    {
      text: 'Impianto in esercizio',
      value: 'connected',
    },
    {
      text: 'Allaccio KO da riprogrammare',
      value: 'ko',
    },
    {
      text: 'Non applicabile',
      value: 'na',
    },
  ]

  verbaleAllaccio: BoxStatusType = 'todo'

  // Aggiorna i campi con gli eventuali nuovi valori della Connection/Lead selezionata
  refresh() {
    console.log(`${this.constructor.name}: refresh()`); // eslint-disable-line no-console

    // Aggiorna i campi con i valori della Connection
    this.egridConnectionStatus = getLeadCustomValueText(this.lead, 'egridConnectionStatus') ?? null;
    this.egridConnectionDate = getLeadCustomValueDate(this.lead, 'egridConnectionDate') ?? null;
    this.egridConnectionTime = getLeadCustomValueText(this.lead, 'egridConnectionTime') ?? null;

    this.suggestedEgridConnectionDate1 = getLeadCustomValueDate(this.lead, 'suggestedEgridConnectionDate1') ?? null;
    this.suggestedEgridConnectionTime1 = getLeadCustomValueText(this.lead, 'suggestedEgridConnectionTime1') ?? null;
    this.suggestedEgridConnectionDate2 = getLeadCustomValueDate(this.lead, 'suggestedEgridConnectionDate2') ?? null;
    this.suggestedEgridConnectionTime2 = getLeadCustomValueText(this.lead, 'suggestedEgridConnectionTime2') ?? null;

    this.egridConnectionActiveDate = getLeadCustomValueDate(this.lead, 'egridConnectionActiveDate') ?? null;

    this.egridDistributorAddress = getLeadCustomValueText(this.lead, 'egridDistributorAddress') ?? null;
    this.egridConnectionNotes = getLeadCustomValueText(this.lead, 'egridConnectionNotes') ?? null;

    this.verbaleAllaccio = (getLeadCustomValueText(this.lead, 'verbaleAllaccio') ?? 'todo') as BoxStatusType;

    // Richiama il metodo del mixin
    return this.mixinRefresh();
  }

  onFieldUpdated(field: string, value: unknown = undefined) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    // Modifico eventuali campi collegati
    const update = {} as { [key: string]: unknown };
    switch (field) {
      // Se è stato modificato egridConnectionStatus...
      case 'egridConnectionStatus':
        // ... e non è stato impostato un valore...
        if (!this.egridConnectionStatus) {
          // ... resetta tutte le date
          this.suggestedEgridConnectionDate1 = null;
          this.suggestedEgridConnectionTime1 = null;
          this.suggestedEgridConnectionDate2 = null;
          this.suggestedEgridConnectionTime2 = null;
          this.egridConnectionDate = null;
          this.egridConnectionTime = null;
          this.egridConnectionActiveDate = null;
          update.suggestedEgridConnectionDate1 = null;
          update.suggestedEgridConnectionTime1 = null;
          update.suggestedEgridConnectionDate2 = null;
          update.suggestedEgridConnectionTime2 = null;
          update.egridConnectionDate = null;
          update.egridConnectionTime = null;
          update.egridConnectionActiveDate = null;
        } else if (this.egridConnectionStatus === 'suggested') {
          // Se è stato impostato a 'suggested' resetta le date successive
          this.egridConnectionDate = null;
          this.egridConnectionTime = null;
          update.egridConnectionDate = null;
          update.egridConnectionTime = null;
        } else if (this.egridConnectionStatus === 'connected') {
          // imposta la egridConnectionActiveDate alla data odierna
          this.egridConnectionActiveDate = moment(moment(), 'YYYY-MM-DD').toDate();
          update.egridConnectionActiveDate = this.egridConnectionActiveDate;
        }
        break;

      default:
        break;
    }
    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });

    // Richiama il metodo del mixin
    return this.mixinOnFieldUpdated(field, value);
  }

  async onShow() {
    console.log(`${this.constructor.name}: onShow()`); // eslint-disable-line no-console

    if (this.connection) {
      // Seleziona la Connection prima di aprire il dialog
      await this.$store.dispatch('selectConnection', { id: this.connection.id });
    }
  }
}
